import * as Sentry from '@sentry/vue'
import { initializeApp, type FirebaseOptions } from '@firebase/app'
import { getAnalytics, setAnalyticsCollectionEnabled } from '@firebase/analytics'
import useCookieConsent from './hooks/useCookieConsent'
import { watch, type App } from 'vue'

import type { Router } from 'vue-router'

const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG) as FirebaseOptions
initializeApp(firebaseConfig)

const { granted } = useCookieConsent()
// configure analytics
const analytics = getAnalytics()
watch(granted, granted => {
  setAnalyticsCollectionEnabled(analytics, granted ?? false)
}, { immediate: true })

export function initSentry ({ app, router }: { app: App, router: Router }) {
  if (import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
      app,
      dsn: import.meta.env.VITE_SENTRY_DSN,
      release: import.meta.env.VITE_SENTRY_RELEASE,
      environment: import.meta.env.VITE_CONTEXT?.toString(),
      integrations: [Sentry.browserTracingIntegration({
        router,
      })],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['api.agm-vote.com'],
    })
  }
}
